import styled from "styled-components";

export const Section = styled.div`
  padding: 30px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HeaderButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
`;

export const PDVName = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 0 30px;
  gap: 0.5rem;
  background: #eaefff;
  border-radius: 20px;
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;

    color: #2d5bff;
  }
`;

export const RoletaButton = styled.button`
  box-sizing: border-box;

  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;

  border-radius: 20px;
  background: #eaefff;
  border: none;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  p {
    margin: 0;
    margin-left: 8px;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: #2d5bff;

    white-space: nowrap;
  }
`;

export const ButtonLogoff = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  height: 40px;

  background: #eaefff;
  border-radius: 50%;
  :hover {
    cursor: pointer;
  }
`;
